import { BatchUpdateManager } from '@/core/item_assistance/batchUpdateManager'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import {
	addItem, tableClearSelectedItems,
	tableShowAllItems,
	tableShowSelectedItems,
	toggleSearchForm
} from '@/core/support_gui_components/table/table'

export function attachToolbarControls (table, itemStructure, component) {
	$('#table_toolbar_add').bind('click', addItem)
	$('#table_toolbar_search').bind('click', toggleSearchForm)
	$('#table_toolbar_all').bind('click', { itemTable: table }, tableShowAllItems)
	$('#table_toolbar_selected_items').bind('click', { itemTable: table }, tableShowSelectedItems)
	$('#table_toolbar_selected_clear').bind('click', { itemTable: table }, tableClearSelectedItems)
	$('#table_toolbar_batch_update').bind('click', function () {
		if (!_.isEmpty(table.selectedItemsManager.getSelections())) {
			window.batchUpdateManager = new BatchUpdateManager(table, itemStructure, component)
		} else {
			showMessageAlert(getLocalizedMessage('items.no.selected'), 'warning')
		}
	})
}

export function unbindToolbarControls (table, itemStructure, component) {
	$('#table_toolbar_add').unbind('click', addItem)
	$('#table_toolbar_search').unbind('click', toggleSearchForm)
	$('#table_toolbar_all').unbind('click', { itemTable: table }, tableShowAllItems)
	$('#table_toolbar_selected_items').unbind('click', { itemTable: table }, tableShowSelectedItems)
	$('#table_toolbar_selected_clear').unbind('click', { itemTable: table }, tableClearSelectedItems)
	$('#table_toolbar_batch_update').unbind('click', function () {
		if (!_.isEmpty(table.selectedItemsManager.getSelections())) {
			window.batchUpdateManager = new BatchUpdateManager(table, itemStructure, component)
		} else {
			showMessageAlert(getLocalizedMessage('items.no.selected'), 'warning')
		}
	})
}

export function setToolbarMode (selectedMode) {
	if (selectedMode) {
		setSelectedItemsToolbarMode()
	} else {
		setAllItemsToolbarMode()
	}
}

export function setAllItemsToolbarMode () {
	$('#table_toolbar_search').show()
	$('#table_toolbar_all').hide()
	$('#table_toolbar_selected_items').show()

}

export function setSelectedItemsToolbarMode () {
	$('#table_toolbar_search').hide()
	$('#table_toolbar_all').show()
	$('#table_toolbar_selected_items').hide()
}

export function setClearSelectedTolbarMode () {
	($('#table_toolbar_selected_count').text() != '0') ? $('#table_toolbar_selected_clear').show() :
		$('#table_toolbar_selected_clear').hide()
}

export function isAllItemMode () {
	return $('#table_toolbar_all').is(':visible')
}
